import ApplicationController from './application_controller'

export default class extends ApplicationController {
  connect() {
    super.connect()

    this.typeSelect = this.element.querySelector("#calendar_type")
    this.liveTitle  = this.element.querySelector("#calendar-component-live-title")

    this.viewPanes = {
      "0": this.element.querySelector("#calendar-month-view"),
      "1": this.element.querySelector("#calendar-week-view"),
      "2": this.element.querySelector("#calendar-day-view")
    }

    this.bindViewChange()
    this.bindNavigation()

    this.syncTitleDisplay()
  }

  bindViewChange() {
    if (!this.typeSelect) return

    this.typeSelect.addEventListener("change", () => {

      Object.keys(this.viewPanes).forEach(key => {
        if (this.viewPanes[key]) {
          this.viewPanes[key].style.display =
            key === this.typeSelect.value ? "block" : "none"
        }
      })

      this.syncTitleDisplay()
    })
  }

  bindNavigation() {
    this.element.querySelectorAll("[data-component-nav]").forEach(button => {

      button.addEventListener("click", () => {

        const activePane = this.activePane()

        if (!activePane) return

        const links = activePane.querySelectorAll(".calendar-heading a")

        if (!links.length) return

        const isPrev = button.dataset.componentNav === "prev"

        const targetLink = isPrev
          ? links[0]
          : links[links.length - 1]

        if (targetLink) {
          targetLink.click()

          setTimeout(() => {
            this.syncTitleDisplay()
          }, 50)
        }
      })
    })
  }

  activePane() {
    return Object.values(this.viewPanes).find(
      pane => pane && pane.style.display !== "none"
    )
  }

  syncTitleDisplay() {
    const activePane = this.activePane()

    if (!activePane) return

    const titleElement =
      activePane.querySelector(".calendar-heading span") ||
      activePane.querySelector(".calendar-title")

    if (!titleElement) return

    this.liveTitle.textContent =
      titleElement.textContent.trim()
  }
}